const initialState = {
  existenciaDiaria: null,
  fechaConsultaStock: null,
  dataLiqMercaderiaFumigada: null,
  detalleLiqMercaderiaFumigada: [],
  dataTotalLiqMercaderiaFumigada: null,
  fechaDesde: null,
  fechaHasta: null,
  detalle: null,
  fileOk: false,
  fileDetallePdfOk: false,
  dataLiqMercaderiaSecada: [],
  detalleLiqMercaderiaSecada: [],
  fechaDPorGrado: null,
  fechaHPorGrado: null,
  fechaDReporteDescarga: null,
  fechaHReporteDescarga: null,
  stockTotal: null,
  tableRowsEstimacion: [],
  cerealesEstimacion: [],
  cerealEstimacionStock: null,
  estimacionExportadores: [],
  receiveEstimacionExportadores: false,
  exportadorProyeccion: null,
  exportadorProyeccionNombre: null,
  exportadoresActivos: [],
  simulacionActiva: false,
  datosProyeccionActualizados: false,
  simulacionesPersistidas: [],
  isSimulacionExportador: false,
  isSimulacion: false,
  espacioDisponibleElevador: null,
  espacioMaximoElevador: 105000,
  cuposAsignadosShow: null,
  cuposProyectados: [],
  cuposProyectadosShow: null,
  fechaProyeccionShow: null,
  fechaProyeccionSeleccionada: null,
  cumplimientoShow: null,
  unidadVisual: 'TN',
  unidadVisualDescarga: 'CAMIONES',
  detalleFechaProyeccion: null
}

export const updateSimulacionesPreliminar = (simulacionesExistentes, newSimulacion) => {
  const index = simulacionesExistentes.findIndex((s) => s.id === newSimulacion.id)
  const isSimulationEmpty = newSimulacion.cuposSimulados === 0 && newSimulacion.cumplimiento === null

  if (isSimulationEmpty) {
    if (index > -1) {
      return [
        ...simulacionesExistentes.slice(0, index),
        ...simulacionesExistentes.slice(index + 1)
      ]
    }
    return simulacionesExistentes
  }

  if (index > -1) {
    return [
      ...simulacionesExistentes.slice(0, index),
      newSimulacion,
      ...simulacionesExistentes.slice(index + 1)
    ]
  } else {
    return [...simulacionesExistentes, newSimulacion]
  }
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'EXISTENCIA_DIARIA':
      return {
        ...state,
        existenciaDiaria: action.data
      }
    case 'ACTUALIZAR_FECHA_CONSULTA_STOCK':
      return {
        ...state,
        fechaConsultaStock: action.fecha
      }
    case 'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA':
      return {
        ...state,
        fechaDesde: action.fechaD,
        fechaHasta: action.fechaH
      }
    case 'ACTUALIZAR_FECHA_STOCK_POR_GRADO':
      return {
        ...state,
        fechaDPorGrado: action.fechaD,
        fechaHPorGrado: action.fechaH
      }
    case 'ACTUALIZAR_FECHA_REPORTE_DESCARGA':
      return {
        ...state,
        fechaDReporteDescarga: action.fechaD,
        fechaHReporteDescarga: action.fechaH
      }
    case 'TOTAL_MERCADERIA_FUMIGADA':
      return {
        ...state,
        dataLiqMercaderiaFumigada: action.data
      }
    case 'TOTAL_DETALLE_MERCADERIA_FUMIGADA':
      return {
        ...state,
        dataTotalLiqMercaderiaFumigada: action.data
      }
    case 'ACTUALIZAR_DETALLES':
      return {
        ...state,
        detalle: action.detalle
      }
    case 'DETALLE_MERCADERIA_FUMIGADA':
      return {
        ...state,
        detalleLiqMercaderiaFumigada: action.data
      }
    case 'GENERAR_PDF':
      return {
        ...state,
        fileOk: action.fileOk
      }
    case 'GENERAR_DETALLE_PDF':
      return {
        ...state,
        fileDetallePdfOk: action.fileDetallePdfOk
      }
    case 'TOTAL_MERCADERIA_SECADA':
      return {
        ...state,
        dataLiqMercaderiaSecada: action.data
      }
    case 'ACTUALIZAR_DETALLES_SECADA':
      return {
        ...state,
        detalle: action.detalle
      }
    case 'DETALLE_MERCADERIA_SECADA':
      return {
        ...state,
        detalleLiqMercaderiaSecada: action.data
      }
    case 'RECEIVE_STOCK_TOTAL':
      return {
        ...state,
        stockTotal: action.stock
      }
    case 'RESET_ESTIMACION_SEMANAL':
      return {
        ...state,
        tableRowsEstimacion: null,
        cerealesEstimacion: null,
        datosProyeccionActualizados: false
      }
    case 'SAVE_ESTIMACION_SEMANAL':
      return {
        ...state,
        tableRowsEstimacion: action.tableRows,
        cerealesEstimacion: action.grupoCereales,
        datosProyeccionActualizados: true
      }
    case 'SAVE_ESTIMACION_SEMANAL_EXPORTADORES':
      return {
        ...state,
        estimacionExportadores: action.data,
        receiveEstimacionExportadores: true
      }
    case 'CUPOS_PROYECTADOS':
      return {
        ...state,
        cuposProyectados: action.data
      }
    case 'CEREAL_ESTIMACION_STOCK':
      return {
        ...state,
        cerealEstimacionStock: action.cereal
      }
    case 'ACTUALIZAR_EXPORTADOR_PROYECCION':
      return {
        ...state,
        exportadorProyeccion: action.exportador,
        exportadorProyeccionNombre: action.razonSocial
      }
    case 'ACTUALIZAR_EXPORTADORES_ACTIVOS':
      return {
        ...state,
        exportadoresActivos: action.exportadores
      }
    case 'SIMULACION_ACTIVA':
      return {
        ...state,
        simulacionActiva: action.simulacion
      }
    case 'SAVE_SIMULACION_PRELIMINAR':
      const updateSimulaciones = updateSimulacionesPreliminar(
        state.simulacionesPersistidas,
        action.payload
      )
      return {
        ...state,
        simulacionesPersistidas: updateSimulaciones
      }
    case 'CLEAN_SIMULACIONES_PERSISTIDAS':
      const exportadorToDelete = action.exportador
      return {
        ...state,
        simulacionesPersistidas: state.simulacionesPersistidas.filter((sim) => sim.exportador !== exportadorToDelete)
      }
    case 'UPDATE_SIMULACION_POR_EXPORTADOR':
      return {
        ...state,
        isSimulacionExportador: action.newValue
      }
    case 'UPDATE_IS_SIMULACION':
      return {
        ...state,
        isSimulacion: action.newValue
      }
    case 'SHOW_DETALLE_CUPOS':
      return {
        ...state,
        cuposAsignadosShow: action.cupos,
        cuposProyectadosShow: action.proyectados,
        fechaProyeccionShow: action.fecha,
        cumplimientoShow: action.cumplimiento,
        descargaPotencialShow: action.descargaPotencial
      }
    case 'RESET_DETALLE_CUPOS':
      return {
        ...state,
        cuposAsignadosShow: null,
        cuposProyectadosShow: null,
        fechaProyeccionShow: null,
        cumplimientoShow: null,
        descargaPotencialShow: null
      }
    case 'SHOW_DETALLE_FECHA':
      return {
        ...state,
        detalleFechaProyeccion: action.detalleFecha
      }
    case 'RESET_DETALLE_FECHA':
      return {
        ...state,
        detalleFechaProyeccion: null
      }
    case 'FECHA_PROYECCION_SELECCIONADA':
      return {
        ...state,
        fechaProyeccionSeleccionada: action.fecha
      }
    case 'UPDATE_ESPACIO_ELEVADOR':
      return {
        ...state,
        espacioDisponibleElevador: action.newValue
      }
    case 'UPDATE_ESPACIO_MAXIMO_ELEVADOR':
      return {
        ...state,
        espacioMaximoElevador: action.newValue
      }
    case 'TOGGLE_UNIDAD_VISUAL':
      const campoUnidad = action.campo
      let nuevaUnidadVisual = state.unidadVisual
      let nuevaUnidadVisualDescarga = state.unidadVisualDescarga

      if (campoUnidad === 'stock') {
        nuevaUnidadVisual = state.unidadVisual === 'TN' ? 'CAMIONES' : 'TN'
      } else if (campoUnidad === 'descarga') {
        nuevaUnidadVisualDescarga = state.unidadVisualDescarga === 'TN' ? 'CAMIONES' : 'TN'
      }

      return {
        ...state,
        unidadVisual: nuevaUnidadVisual,
        unidadVisualDescarga: nuevaUnidadVisualDescarga
      }
    default:
      return state
  }
}
